import React from 'react';
import { Calendar, User, ArrowRight } from 'lucide-react';

const BlogPage: React.FC = () => {
  const blogPosts = [
    {
      id: 1,
      title: 'Understanding Mental Health in the Modern Workplace',
      excerpt: 'Exploring the importance of mental health support in today\'s work environments and how organizations can better support their employees.',
      date: '2024-03-15',
      author: 'Health City Team',
      category: 'Workplace Wellbeing'
    },
    {
      id: 2,
      title: 'The Benefits of Cognitive Behavioral Therapy',
      excerpt: 'An in-depth look at how CBT can help manage anxiety, depression, and other mental health conditions through evidence-based techniques.',
      date: '2024-03-10',
      author: 'Dr. Sarah Johnson',
      category: 'Treatment Approaches'
    },
    {
      id: 3,
      title: 'Building Resilience: Tips for Mental Wellbeing',
      excerpt: 'Practical strategies and techniques to build emotional resilience and maintain positive mental health in challenging times.',
      date: '2024-03-05',
      author: 'Health City Team',
      category: 'Self-Help'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-700 to-slate-900 text-white py-20">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Health City Blog
          </h1>
          <p className="text-xl text-slate-200 max-w-3xl mx-auto">
            Insights, tips, and expert advice on mental health and wellbeing
          </p>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <article
              key={post.id}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-200"
            >
              <div className="p-6">
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
                  <Calendar className="w-4 h-4" />
                  <span>{new Date(post.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                </div>
                
                <span className="inline-block bg-blue-100 text-blue-600 text-xs font-semibold px-3 py-1 rounded-full mb-3">
                  {post.category}
                </span>
                
                <h2 className="text-xl font-bold text-gray-900 mb-3">
                  {post.title}
                </h2>
                
                <p className="text-gray-600 mb-4">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                  <div className="flex items-center gap-2 text-sm text-gray-500">
                    <User className="w-4 h-4" />
                    <span>{post.author}</span>
                  </div>
                  
                  <button className="text-blue-600 hover:text-blue-700 font-semibold text-sm flex items-center gap-1">
                    Read More
                    <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Coming Soon Message */}
        <div className="mt-12 text-center bg-blue-50 border-2 border-blue-200 rounded-lg p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">More Articles Coming Soon</h3>
          <p className="text-gray-600">
            We're continuously adding new content to help you on your mental health journey. 
            Check back regularly for updates!
          </p>
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
